import http from './http'
let resquest = "/apis"

//修改用户信息
export function modifyInfo(params){
    return http.put(`${resquest}/system/user/profile`,params)
}

//给邮箱发送验证码
export function emailCode(params){
    return http.get(`${resquest}/system/user/profile/email/code`,params)
}

//修改手机号码
export function updatePhone(params){
    return http.post(`${resquest}/system/user/profile/updatePhone`,params)
}

//修改绑定邮箱
export function updateEmail(params){
    return http.post(`${resquest}/system/user/profile/updateEmail`,params)
}

//修改密码
export function updatePwd(params){
    return http.post(`${resquest}/system/user/profile/updatePwd`,params)
}